var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.$router.currentRoute.path !== '/')?_c('Menu'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }